/* tslint:disable */
/* eslint-disable */
/**
 * KNMI exons API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { MaritimeArea } from '../types';
// @ts-ignore
import type { MaritimeForecast } from '../types';
// @ts-ignore
import type { MaritimeWarning } from '../types';
// @ts-ignore
import type { PublicWarningsLegacyComment } from '../types';
// @ts-ignore
import type { PublicWarningsSnapshot } from '../types';
// @ts-ignore
import type { StaticMapOverlaysOverlay } from '../types';
// @ts-ignore
import type { StaticMapOverlaysOverlayBase } from '../types';
/**
 * DataApi - axios parameter creator
 * @export
 */
export const DataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the latest forecast for a maritime domain
         * @summary Get latest Maritime Forecast for a Domain
         * @param {string} domainId Maritime::Forecasts::Domain public_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastForMaritimeDomain: async (domainId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'domainId' is not null or undefined
            assertParamExists('getForecastForMaritimeDomain', 'domainId', domainId)
            const localVarPath = `/data/maritime/forecasts/{domain_id}`
                .replace(`{${"domain_id"}}`, encodeURIComponent(String(domainId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a single maritime area with its category and geometry
         * @summary Get a Maritime Area
         * @param {string} id Maritime Area public_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaritimeArea: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMaritimeArea', 'id', id)
            const localVarPath = `/data/maritime/areas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the public warnings comment from the legacy early warning API
         * @summary Get the legacy public warnings comment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicWarningsLegacyComment: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data/public_warnings/legacy_comment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the latest public warnings snapshot from the KNMI DataHub. Snapshots with publication_type test are excluded unless the environment includes test data.
         * @summary Get the latest public warnings snapshot
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicWarningsSnapshot: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data/public_warnings/snapshot`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a single static map overlay with its (GeoJSON) data
         * @summary Get a StaticMapOverlay
         * @param {string} id StaticMapOverlay public_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticMapOverlay: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getStaticMapOverlay', 'id', id)
            const localVarPath = `/data/static_map_overlays/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all maritime areas with their category and geometry
         * @summary List all Maritime Areas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMaritimeAreas: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data/maritime/areas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all warnings from the latest warnings publication
         * @summary List latest Maritime Warnings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMaritimeWarnings: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data/maritime/warnings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists all static map overlays
         * @summary List all StaticMapOverlays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStaticMapOverlays: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/data/static_map_overlays`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataApi - functional programming interface
 * @export
 */
export const DataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the latest forecast for a maritime domain
         * @summary Get latest Maritime Forecast for a Domain
         * @param {string} domainId Maritime::Forecasts::Domain public_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForecastForMaritimeDomain(domainId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaritimeForecast>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForecastForMaritimeDomain(domainId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getForecastForMaritimeDomain']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a single maritime area with its category and geometry
         * @summary Get a Maritime Area
         * @param {string} id Maritime Area public_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMaritimeArea(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MaritimeArea>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMaritimeArea(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getMaritimeArea']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the public warnings comment from the legacy early warning API
         * @summary Get the legacy public warnings comment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicWarningsLegacyComment(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicWarningsLegacyComment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicWarningsLegacyComment(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getPublicWarningsLegacyComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the latest public warnings snapshot from the KNMI DataHub. Snapshots with publication_type test are excluded unless the environment includes test data.
         * @summary Get the latest public warnings snapshot
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPublicWarningsSnapshot(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicWarningsSnapshot>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPublicWarningsSnapshot(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getPublicWarningsSnapshot']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a single static map overlay with its (GeoJSON) data
         * @summary Get a StaticMapOverlay
         * @param {string} id StaticMapOverlay public_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStaticMapOverlay(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StaticMapOverlaysOverlay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStaticMapOverlay(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.getStaticMapOverlay']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists all maritime areas with their category and geometry
         * @summary List all Maritime Areas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMaritimeAreas(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MaritimeArea>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMaritimeAreas(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.listMaritimeAreas']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all warnings from the latest warnings publication
         * @summary List latest Maritime Warnings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listMaritimeWarnings(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MaritimeWarning>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listMaritimeWarnings(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.listMaritimeWarnings']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Lists all static map overlays
         * @summary List all StaticMapOverlays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStaticMapOverlays(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StaticMapOverlaysOverlayBase>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStaticMapOverlays(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataApi.listStaticMapOverlays']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataApi - factory interface
 * @export
 */
export const DataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataApiFp(configuration)
    return {
        /**
         * Returns the latest forecast for a maritime domain
         * @summary Get latest Maritime Forecast for a Domain
         * @param {string} domainId Maritime::Forecasts::Domain public_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastForMaritimeDomain(domainId: string, options?: RawAxiosRequestConfig): AxiosPromise<MaritimeForecast> {
            return localVarFp.getForecastForMaritimeDomain(domainId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a single maritime area with its category and geometry
         * @summary Get a Maritime Area
         * @param {string} id Maritime Area public_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMaritimeArea(id: string, options?: RawAxiosRequestConfig): AxiosPromise<MaritimeArea> {
            return localVarFp.getMaritimeArea(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the public warnings comment from the legacy early warning API
         * @summary Get the legacy public warnings comment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicWarningsLegacyComment(options?: RawAxiosRequestConfig): AxiosPromise<PublicWarningsLegacyComment> {
            return localVarFp.getPublicWarningsLegacyComment(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the latest public warnings snapshot from the KNMI DataHub. Snapshots with publication_type test are excluded unless the environment includes test data.
         * @summary Get the latest public warnings snapshot
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPublicWarningsSnapshot(options?: RawAxiosRequestConfig): AxiosPromise<PublicWarningsSnapshot> {
            return localVarFp.getPublicWarningsSnapshot(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a single static map overlay with its (GeoJSON) data
         * @summary Get a StaticMapOverlay
         * @param {string} id StaticMapOverlay public_id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStaticMapOverlay(id: string, options?: RawAxiosRequestConfig): AxiosPromise<StaticMapOverlaysOverlay> {
            return localVarFp.getStaticMapOverlay(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all maritime areas with their category and geometry
         * @summary List all Maritime Areas
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMaritimeAreas(options?: RawAxiosRequestConfig): AxiosPromise<Array<MaritimeArea>> {
            return localVarFp.listMaritimeAreas(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all warnings from the latest warnings publication
         * @summary List latest Maritime Warnings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listMaritimeWarnings(options?: RawAxiosRequestConfig): AxiosPromise<Array<MaritimeWarning>> {
            return localVarFp.listMaritimeWarnings(options).then((request) => request(axios, basePath));
        },
        /**
         * Lists all static map overlays
         * @summary List all StaticMapOverlays
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStaticMapOverlays(options?: RawAxiosRequestConfig): AxiosPromise<Array<StaticMapOverlaysOverlayBase>> {
            return localVarFp.listStaticMapOverlays(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataApi - object-oriented interface
 * @export
 * @class DataApi
 * @extends {BaseAPI}
 */
export class DataApi extends BaseAPI {
    /**
     * Returns the latest forecast for a maritime domain
     * @summary Get latest Maritime Forecast for a Domain
     * @param {string} domainId Maritime::Forecasts::Domain public_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    public getForecastForMaritimeDomain(domainId: string, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getForecastForMaritimeDomain(domainId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a single maritime area with its category and geometry
     * @summary Get a Maritime Area
     * @param {string} id Maritime Area public_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    public getMaritimeArea(id: string, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getMaritimeArea(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the public warnings comment from the legacy early warning API
     * @summary Get the legacy public warnings comment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    public getPublicWarningsLegacyComment(options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getPublicWarningsLegacyComment(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the latest public warnings snapshot from the KNMI DataHub. Snapshots with publication_type test are excluded unless the environment includes test data.
     * @summary Get the latest public warnings snapshot
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    public getPublicWarningsSnapshot(options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getPublicWarningsSnapshot(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a single static map overlay with its (GeoJSON) data
     * @summary Get a StaticMapOverlay
     * @param {string} id StaticMapOverlay public_id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    public getStaticMapOverlay(id: string, options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).getStaticMapOverlay(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all maritime areas with their category and geometry
     * @summary List all Maritime Areas
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    public listMaritimeAreas(options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).listMaritimeAreas(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all warnings from the latest warnings publication
     * @summary List latest Maritime Warnings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    public listMaritimeWarnings(options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).listMaritimeWarnings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Lists all static map overlays
     * @summary List all StaticMapOverlays
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataApi
     */
    public listStaticMapOverlays(options?: RawAxiosRequestConfig) {
        return DataApiFp(this.configuration).listStaticMapOverlays(options).then((request) => request(this.axios, this.basePath));
    }
}

